// extracted by mini-css-extract-plugin
export default {"copyIcon":"CopyToClipboard_copyIcon__FxTDd"};